import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'FormSpacing';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')((
  {
    theme,
  },
) => ({
  [`&.${classes.root}`]: {
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

interface FormSpacingProps {
  children: React.ReactNode
}

const FormSpacing = ({ children }: FormSpacingProps) => (
  <Root className={classes.root}>
    {children}
  </Root>
);

export default FormSpacing;
